import type { IShopper } from '@makemydeal/dr-platform-types';
import type { Dealership } from '@makemydeal/dr-activities-dealership-picker';
import * as Actions from '@makemydeal/dr-dash-store/actionTypes/openDealActionTypes';

export const updateDealership = (dealer: Dealership): any => {
    return {
        type: Actions.DEALERSHIP_UPDATE,
        payload: {
            ...dealer
        }
    };
};

export const updateCommonConsumer = (consumer: IShopper): any => {
    return {
        type: Actions.COMMON_CONSUMER_UPDATE,
        payload: {
            selectedConsumer: consumer
        }
    };
};

export const updateCommonConsumerValidationState = (isConsumerValid: boolean): any => {
    return {
        type: Actions.COMMON_CONSUMER_UPDATE_VALIDATION_STATE,
        payload: {
            isConsumerValid
        }
    };
};

export const openDeal = () => {
    return {
        type: Actions.OPEN_DEAL
    };
};

export const syncConsumerData = (value: boolean) => {
    return {
        type: Actions.SYNC_CONSUMER_DATA,
        payload: value
    };
};

export const toggleChangeVehicleEditView = () => {
    return {
        type: Actions.TOGGLE_CHANGE_VEHICLE_EDIT_VIEW
    };
};

export const switchVehicleHideLoader = () => {
    return {
        type: Actions.SWITCH_VEHICLE_HIDE_LOADER
    };
};
